module.exports = __webpack_public_path__ + "img/Cocos (Keeling) Islands.70894ae1.svg";